import type { StockLotDetailDTO } from "@/modules/inventory/domain/types";

export type OrderLineLotPick = {
  stockLotId: string;
  quantity: number;
  receiptId: string;
  receiptNumber: string;
  quantityRemaining: number;
  unitLandedCost: string;
};

export function buildFifoLotPicks(
  lots: StockLotDetailDTO[],
  saleQuantity: number,
  unitsPerSale = 1,
): OrderLineLotPick[] {
  let remainingSale = saleQuantity;
  const picks: OrderLineLotPick[] = [];

  for (const lot of lots) {
    if (remainingSale <= 0) break;
    const maxSaleFromLot = Math.floor(
      lot.quantityRemaining / Math.max(unitsPerSale, 1),
    );
    const take = Math.min(remainingSale, maxSaleFromLot);
    if (take <= 0) continue;

    picks.push({
      stockLotId: lot.id,
      quantity: take,
      receiptId: lot.receiptId,
      receiptNumber: lot.receiptNumber,
      quantityRemaining: lot.quantityRemaining,
      unitLandedCost: lot.unitLandedCost,
    });
    remainingSale -= take;
  }

  return picks;
}

export function sumLotPickQuantity(picks: OrderLineLotPick[]) {
  return picks.reduce((sum, pick) => sum + pick.quantity, 0);
}

export function toApiLotPicks(picks: OrderLineLotPick[]) {
  return picks.map((pick) => ({
    stockLotId: pick.stockLotId,
    quantity: pick.quantity,
  }));
}
